import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
interface AICompanionProps {
  message: string;
  mood?: 'happy' | 'excited' | 'calm';
}
export function AICompanion({
  message,
  mood = 'happy'
}: AICompanionProps) {
  return <div className="flex items-start gap-4 mb-8" data-id="element-57">
      <motion.div className="relative flex-shrink-0" whileHover={{
      scale: 1.1,
      rotate: 5
    }} whileTap={{
      scale: 0.9
    }} data-id="element-58">
        <div className="w-16 h-16 rounded-2xl bg-game-purple flex items-center justify-center shadow-lg shadow-game-purple/30 border-4 border-white" data-id="element-59">
          <Sparkles className="w-8 h-8 text-white" data-id="element-60" />
        </div>
        <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-game-yellow rounded-full border-2 border-white flex items-center justify-center" data-id="element-61">
          <span className="text-xs" data-id="element-62">✨</span>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 10,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      delay: 0.2
    }} className="bg-white p-4 rounded-3xl rounded-tl-none shadow-sm border border-purple-50 relative" data-id="element-63">
        <p className="font-quicksand font-medium text-game-dark text-sm leading-relaxed" data-id="element-64">
          {message}
        </p>
      </motion.div>
    </div>;
}